import Montez1 from '../../../Media/BSD/Tresor/Tresor Montez.webp'
import Montez2 from '../../../Media/BSD/Tresor/Tresor Montez.webp'





const Montezimages =[
Montez1,Montez2
]

export default Montezimages;